// consoleGuard — prints a one-time warning in the browser devtools console.
//
// Honest scope: a static site can't detect or stop a real attacker from the
// client. The ONE thing a console message genuinely defends against is the
// "Self-XSS" scam — where someone is socially-engineered into pasting
// attacker-supplied code into their own console ("paste this to unlock X").
// Big platforms (Facebook, Discord, Google) all ship this banner for exactly
// that reason. Everything else here is just Sam's voice having a moment.

let printed = false;

export function printConsoleGuard() {
  if (printed || typeof console === "undefined" || typeof window === "undefined") return;
  printed = true;

  const head = "font: 700 22px/1.5 Georgia, serif; color:#1A1A1A;";
  const warn = "font: 700 13px/1.7 ui-monospace, monospace; color:#c0392b;";
  const body = "font: 13px/1.7 ui-monospace, monospace; color:#5a5a5a;";

  try {
    // eslint-disable-next-line no-console
    console.log("%cWait. 👀", head);
    // eslint-disable-next-line no-console
    console.log(
      "%cIf someone told you to paste something in here to “unlock”, “hack”, or “verify” anything on erpik.com — they're playing you, not me. That's the Self-XSS scam. Don't paste code you don't understand into a console. Ever.",
      warn,
    );
    // eslint-disable-next-line no-console
    console.log(
      "%cIf you're a dev poking around for fun: respect. The stack is React + a pile of Netlify functions, all open to read in the bundle. Found something sharp? The contact form's on the page — Sam reads every message himself.",
      body,
    );
  } catch {}
}
